<div class="ruckit-customer-reference-selector">
  <div class="ruckit-customer-reference-selector__search-bar">
    <i
      *ngIf="visible"
      class="icon-close ruckit-customer-reference-selector__search-bar__close"
      (click)="onCloseClick()"
    >
    </i>
    <i
      *ngIf="hasControls && !visible"
      class="icon-pencil ruckit-customer-reference-selector__search-bar__edit"
      [ngClass]="{'icon-disabled': !selectedCustomerReference}"
      (click)="selectedCustomerReference && onEditReferenceClick()"
    >
    </i>
    <i
      *ngIf="hasControls && !visible"
      class="icon-search ruckit-customer-reference-selector__search-bar__search"
      (click)="onInputFocus()"
    >
    </i>
    <input
      #customerReferenceInput
      matInput
      class="search"
      type="text"
      [disabled]="!visible"
      [placeholder]="placeholder"
      (blur)="onInputBlur()"
      (input)="onSearchChange($event.target.value)"
      [(ngModel)]="value"
    />
  </div>
  <div class="ruckit-customer-reference-selector__results--container">
    <div
      *ngIf="visible"
      class="ruckit-customer-reference-selector__results"
      infiniteScroll
      [infiniteScrollDistance]="scrollDistance"
      [infiniteScrollUpDistance]="scrollUpDistance"
      [infiniteScrollThrottle]="throttle"
      [scrollWindow]="false"
      (scrolled)="onScrollDown()"
      (scrolledUp)="onScrollUp()"
    >
      <div *ngIf="loading" class="ruckit-customer-reference-selector__results__loader">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
      <div *ngIf="!loading && references.length <= 0" class="ruckit-customer-reference-selector__results__missing">
        <div class="ruckit-customer-reference-selector__result">
          No References Found
        </div>
      </div>
      <div *ngFor="let reference of references">
        <div class="ruckit-customer-reference-selector__result" (mousedown)="onReferenceClicked($event, reference)">
          <div class="ruckit-customer-reference-selector__result__title">
            {{ reference.customerName }} - {{ reference.customerCode }}
          </div>
          <div class="ruckit-customer-reference-selector__result__content">
            <div class="ruckit-customer-reference-selector__result__content__item">
              <div class="ruckit-customer-reference-selector__result__content__item__header">{{ 'Customer Name' | translate }}</div>
              <div class="ruckit-customer-reference-selector__result__content__item__content">{{ reference.customerName }}</div>
            </div>
            <div class="ruckit-customer-reference-selector__result__content__item">
              <div class="ruckit-customer-reference-selector__result__content__item__header">{{ 'Address' | translate }}</div>
              <div class="ruckit-customer-reference-selector__result__content__item__content">{{ reference.customerAddress1 }}</div>
            </div>
            <div class="ruckit-customer-reference-selector__result__content__item">
              <div class="ruckit-customer-reference-selector__result__content__item__header">{{ 'City' | translate }}</div>
              <div class="ruckit-customer-reference-selector__result__content__item__content">{{ reference.customerCity }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="visible" class="ruckit-customer-reference-selector__footer">
      <i class="icon icon-plus"></i>
      <div class="ruckit-customer-reference-selector__footer__content" (mousedown)="onAddClick()">
        {{ 'Add New Customer Reference' | translate }}
      </div>
    </div>
  </div>
</div>
